import React from 'react';
import { createRoot } from 'react-dom/client';
import { AlpineComponent } from 'alpinejs';

import { getTypesenseSearchClient } from '../../../javascripts/typesense';
import { default as SearchListRoot } from './components/SearchList';
import { TypesenseSearchConfig } from '../../../javascripts/typesense';
import SearchListProvider from './context/SearchListProvider';

export type SearchListData = {
  i18n: {
    submitSearch: string;
    resetSearch: string;
    searchResults: string;
    searchQuery: string;
    loadMore: string;
  };
  search: {
    resultsHidden: boolean;
    queryBy: string | string[];
    sortBy?: string;
    filters?: string;
    limit?: number;
    config: TypesenseSearchConfig;
  };
};

const SearchList = ({ i18n, search }: SearchListData): AlpineComponent => ({
  init() {
    const searchClient = getTypesenseSearchClient(
      {
        query_by: search.queryBy,
        limit: search.limit,
        sort_by: search.sortBy
      },
      search.config
    );

    const root = createRoot(this.$root);

    root.render(
      <SearchListProvider search={search} i18n={i18n}>
        <SearchListRoot
          searchClient={searchClient}
          indexName={search.config.indexName}
        />
      </SearchListProvider>
    );
  }
});

export default SearchList;
